export default "__VITE_ASSET__abcb02f6__"